<!--
  Vencord WebInstaller, a web frontend for the Vencord Installer
  Copyright (c) 2023 Vendicated, Justice Almanzar and Vencord contributors
  SPDX-License-Identifier: GPL-3.0-or-later
-->

<img src="https://media.discordapp.net/stickers/1039992459209490513.png?size=240" alt="shiggy" />

<style>
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>
